import {Dayjs} from 'dayjs';

export type FilterType = 'Dia' |
    'Mes' |
    'Recurso' |
    'ContaContabil' |
    'ContaDia' |
    'ContaMes' |
    'RecursoDia' |
    'RecursoMes'

export const DashSoliAgrupamentoFilterTypeValues: FilterType[] = [
    'Dia',
    'Mes',
    'Recurso',
    'RecursoDia',
    'RecursoMes',
    'ContaContabil',
    'ContaDia',
    'ContaMes'
];


export interface IDashSolicitacaoFilters {
    dataInicio?: Dayjs;
    dataFim?: Dayjs;
    idRecurso?: number[];
    idContaContabil?: number[];
    agrupamento?: FilterType;
}